const loadItems = (button, minItemsToLoad = 0, initialItemCount = null) => {
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage+1;
 /* const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPageScroll);  */
  const cleanUrl = $('[data-next-url]').val().replace(/&phcursor=[^&]+/, '');
  const nextUrl = cleanUrl.replace(/page=[0-9]+/, 'page=' + currentPage);
  const nextUrlScroll = cleanUrl.replace(/page=[0-9]+/, 'page=' + currentPageScroll);
  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  // Se è il primo caricamento di questa sessione, salva il conteggio iniziale
  // IMPORTANTE: Conta solo i prodotti REALMENTE VISIBILI (esclude hidden, display:none, visibility:hidden)
  if (initialItemCount === null) {
    initialItemCount = $('.load-more-grid > li').filter(function() {
      const $item = $(this);
      // Escludi se ha class product-hidden
      if ($item.hasClass('product-hidden')) return false;
      // Escludi se ha display: none o visibility: hidden
      const styles = window.getComputedStyle(this);
      return styles.display !== 'none' && styles.visibility !== 'hidden';
    }).length;
  }

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      // Calcola quanti prodotti abbiamo aggiunto IN QUESTA SESSIONE DI LOAD MORE
      const currentVisibleCount = $('.load-more-grid > li').filter(function() {
        const $item = $(this);
        if ($item.hasClass('product-hidden')) return false;
        const styles = window.getComputedStyle(this);
        return styles.display !== 'none' && styles.visibility !== 'hidden';
      }).length;
      const addedSoFar = currentVisibleCount - initialItemCount;
      const itemsStillNeeded = minItemsToLoad - addedSoFar;
      
      console.log('[Load More] 📄 Pagina Shopify caricata:', currentPage + '/' + totalPages);
      console.log('[Load More] 📊 Prodotti già aggiunti in questo Load More:', addedSoFar + '/' + minItemsToLoad);
      console.log('[Load More] 🎯 Prodotti ancora necessari:', itemsStillNeeded);
      
      // Performance monitoring
      if (window.performanceOptimizations && window.performanceOptimizations.monitor) {
        window.performanceOptimizations.monitor.mark('load-more-page-' + currentPage);
      }
      
      // Estrai SOLO i prodotti REALMENTE visibili dalla nuova pagina
      const newProducts = $(responseHTML).find('.load-more-grid > li').filter(function() {
        const $item = $(this);
        if ($item.hasClass('product-hidden')) return false;
        // Per i nuovi prodotti non possiamo usare getComputedStyle, usiamo solo le classi CSS
        const style = $item.attr('style') || '';
        return !style.includes('display: none') && !style.includes('visibility: hidden');
      });
      console.log('[Load More] 📦 Prodotti visibili trovati nella pagina:', newProducts.length);
      
      // Aggiungi solo i prodotti necessari per raggiungere ESATTAMENTE il target (es. 40)
      // Usa requestIdleCallback per ridurre il lavoro sul main thread
      let addedFromThisPage = 0;
      const addProductsInChunks = (startIndex = 0) => {
        const chunkSize = window.PerformanceConfig?.loadMore?.chunkSize || 5; // Aumentato da 3 a 5
        const endIndex = Math.min(startIndex + chunkSize, newProducts.length);
        
        // Usa DocumentFragment per ridurre reflow
        const fragment = document.createDocumentFragment();
        
        for (let i = startIndex; i < endIndex && addedFromThisPage < itemsStillNeeded; i++) {
          const clonedElement = $(newProducts[i]).clone()[0];
          fragment.appendChild(clonedElement);
          addedFromThisPage++;
        }
        
        // Aggiungi tutto in una volta per ridurre reflow
        $('.load-more-grid')[0].appendChild(fragment);
        
        // Se ci sono ancora prodotti da aggiungere, continua nel prossimo idle
        if (addedFromThisPage < itemsStillNeeded && endIndex < newProducts.length) {
          const idleTimeout = window.PerformanceConfig?.loadMore?.idleTimeout || 16;
          window.PerformanceUtils?.requestIdleCallback(
            () => addProductsInChunks(endIndex), 
            { timeout: idleTimeout }
          );
        }
      };
      
      addProductsInChunks();
      
      console.log('[Load More] ➕ Prodotti aggiunti da questa pagina:', addedFromThisPage);
      
      // Cleanup per ridurre memoria
      if (window.performanceOptimizations && window.performanceOptimizations.elementPool) {
        // Pulisci elementi non più necessari
        const oldElements = document.querySelectorAll('.load-more-grid > li[data-old]');
        oldElements.forEach(el => el.remove());
      }
      
      colorSwatches();
      
      // Ricalcola il totale
      const newTotalVisible = $('.load-more-grid > li').filter(function() {
        const $item = $(this);
        if ($item.hasClass('product-hidden')) return false;
        const styles = window.getComputedStyle(this);
        return styles.display !== 'none' && styles.visibility !== 'hidden';
      }).length;
      const totalAddedNow = newTotalVisible - initialItemCount;
      
      console.log('[Load More] 📊 Totale prodotti aggiunti ora:', totalAddedNow + '/' + minItemsToLoad);
      console.log('[Load More] 📈 Totale prodotti visibili in pagina:', newTotalVisible);
      
      // CONTINUA a caricare SOLO se non abbiamo raggiunto i 40 prodotti per questo Load More
      if (minItemsToLoad > 0 && totalAddedNow < minItemsToLoad && currentPage < totalPages) {
        console.log('[Load More] ⚠️ Mancano ancora ' + (minItemsToLoad - totalAddedNow) + ' prodotti per questo Load More');
        console.log('[Load More] 🔄 Caricamento pagina Shopify successiva...');
        // Richiama loadItems ricorsivamente
        setTimeout(() => {
          loadItems(button, minItemsToLoad, initialItemCount);
        }, 100);
        return; // IMPORTANTE: esci qui
      }
      
      if (totalAddedNow >= minItemsToLoad) {
        console.log('[Load More] ✅ PERFETTO! Aggiunti esattamente ' + totalAddedNow + ' prodotti visibili');
        console.log('[Load More] 🎉 Totale pagina: ' + newTotalVisible + ' prodotti visibili');
      } else if (currentPage >= totalPages) {
        console.log('[Load More] ⚠️ Fine pagine - Aggiunti ' + totalAddedNow + ' prodotti (target era ' + minItemsToLoad + ')');
      }
      
      // Se siamo arrivati qui, il caricamento è completo
      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl =  nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value =  nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage =  currentPage;
          scollData.querySelector('input[data-current-page]').value =  currentPage;
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      }
    },
    error: function() {
      // In caso di errore, riabilita il pulsante
      console.log('[Load More] ❌ Errore nel caricamento');
      button.removeAttribute("disabled");
      button.classList.remove('loading');
    }
  })
}

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  
  spinnerList.forEach(spinner => {
    // Leggi il numero di prodotti per pagina dal data attribute della griglia
    const productGrid = document.querySelector('.load-more-grid');
    const productsPerPage = productGrid ? parseInt(productGrid.getAttribute('data-products-per-page')) || 15 : 15;
    
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner, productsPerPage);
          }
        })
      }
    );

    sectionObserver.observe(spinner);
  })
}

function loadMore() {  
  // Leggi il numero di prodotti per pagina dal data attribute della griglia
  const productGrid = document.querySelector('.load-more-grid');
  const productsPerPage = productGrid ? parseInt(productGrid.getAttribute('data-products-per-page')) || 15 : 15;
  
  console.log('[Load More] Inizializzazione - Prodotti per pagina:', productsPerPage);
  console.log('[Load More] Data attribute trovato:', productGrid ? productGrid.getAttribute('data-products-per-page') : 'NON TROVATO');
  
  // CHECK INIZIALE: Verifica se la pagina 1 ha abbastanza prodotti REALMENTE visibili
  if (productGrid) {
    const visibleProducts = $(productGrid).find('> li').filter(function() {
      const $item = $(this);
      if ($item.hasClass('product-hidden')) return false;
      const styles = window.getComputedStyle(this);
      return styles.display !== 'none' && styles.visibility !== 'hidden';
    }).length;
    const loadMoreButton = document.querySelector('.js-load-more');
    
    console.log('[Load More] 🔍 Check caricamento iniziale:');
    console.log('[Load More] Prodotti visibili in pagina 1:', visibleProducts);
    console.log('[Load More] Target prodotti:', productsPerPage);
    
    if (visibleProducts < productsPerPage && loadMoreButton) {
      const missing = productsPerPage - visibleProducts;
      console.log('[Load More] ⚠️ Pagina 1 incompleta! Mancano ' + missing + ' prodotti');
      console.log('[Load More] 🔄 Caricamento automatico per completare la pagina...');
      
      // Simula un click automatico sul pulsante Load More per completare
      setTimeout(() => {
        loadItems(loadMoreButton, missing);
      }, 500);
    } else {
      console.log('[Load More] ✅ Pagina 1 completa');
    }
  }
  
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      console.log('[Load More] Click sul pulsante - Richiesti', productsPerPage, 'prodotti');
      loadItems(button, productsPerPage);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();